import resso from 'resso';


const jmodel = resso({
  titles: []
});

export default jmodel